import React from "react"

import DefaultLayout from "../layouts/default"
import TwoThirdsGrid from "../components/layout/TwoThirdsGrid"
import Text from "../components/text/Text"
import HeadlineWithSub from "../components/text/HeadlineWithSub"
import DottedLineHorizontal from "../components/DottedLineHorizontal"
import { Link } from "gatsby"

const active = {
  title: "Preise"
}

const Preise = () =>
  <DefaultLayout image="/assets/images/IMG_6972.jpeg" active={active}>
    <TwoThirdsGrid textRight>
      <div>
        <HeadlineWithSub>
          <h1>Preise</h1>
        </HeadlineWithSub>
      </div>
      <Text>
        <p>
          <strong>
            Mal- und Gestaltungstherapie für Kinder, Jugendliche und Erwachsene<br />
          </strong>
          auf Anfrage<br />
        </p>
        <p>
          <strong>
            Kunstorientierte Supervision und Coaching<br />
          </strong>
          auf Anfrage<br /><br />
          Zusätzliche Aufwendungen wie Telefongespräche, Berichte, Mails, usw. werden nach effektivem Zeitaufwand auf
          der Basis des Stundenhonorars berechnet.
        </p>
        
        <p>
         Die Leistungen für Kunsttherapie können von vielen Krankenkassen ganz oder teilweise über die Zusatzversicherung abgerechnet werden. Erkundigen Sie sich bitte vor Therapiebeginn bei ihrer Krankenkasse.
        </p>
        <p>Die Leistungen für Coaching sind nicht krankenkassenanerkannt.</p>

        <DottedLineHorizontal />

        <p>
          <strong>Terminabsagen</strong><br />
          Die Termine werden in gegenseitiger Absprache festgelegt und sind beidseitig verbindlich. Bitte denken Sie
          daran, im Verhinderungsfall mindestens 24h vor Ihrem vereinbarten Termin telefonisch Bescheid zu geben. Für
          verspätete Abmeldungen wird ein Stundenhonorar in Rechnung gestellt.
        </p>
        <p>
          <strong>An-/Abmeldung Weiterbildungen/Workshops</strong><br />
          Weiterbildungs-/Workshopabmeldungen müssen schriftlich bis 14 Tage vor Beginn der Weiterbildung bzw. des Workshops erfolgen. Bei einer Abmeldung bis zu 7 Tage vor Weiterbildungs-/Workshopbeginn fallen Fr. 30.— Bearbeitungsgebühr an. Bis 3 Tage vor Beginn fallen 50 % der Weiterbildungs-/Workshopkosten an. Bei Abmeldungen später als 3 Tage vor Beginn werden die vollen Weiterbildungs-/Workshopkosten verrechnet. <br />
          In jedem Fall kann ein Ersatzteilnehmer gestellt werden, so dass lediglich eine Bearbeitungsgebühr von Fr. 30.-- entstehen. Es besteht kein Anspruch auf Ersatz eines versäumten Veranstaltungstages. <br />
        </p>
        <p>
          <strong>Reisespesen</strong><br />
          Findet der Termin bei dem/den Klienten vor Ort statt, werden die Reisespesen (öV 1. Klasse Halbtax) vom
          Auftraggeber getragen.
        </p>
        <p>
          <strong>Die vollständigen Allgemeinen Geschäftsbedingungen siehe unter <Link to="/agb">AGB</Link></strong>
        </p>
      </Text>
    </TwoThirdsGrid>
  </DefaultLayout>

export default Preise